import { writable } from "svelte/store";

// Used to set the theme of the Global Navigation
export const heroThemeStore = writable("transparent");

// Used to store the form factor of the Hero component, which will be used to determine the theme of the navigation bar
export const heroFormFactorStore = writable("");

// Used to store applied filter items
export const filterItemsStore = writable([]);

// Used to store the selected newsletters on our newsletters component
export const selectedNewsletters = writable({});

// Use to store whether or not our mobile navigation is expanded
export const mobileNavExpansionStore = writable(false);
